// ignore-string-externalization

import { css } from 'styled-components';

export const isHelpLive = true;

export const HELP_LIST_TRACK_CAT = 'Help List';

export const hidden = css`
  visibility: hidden;
  height: 0;
  padding: 0;
  margin: 0;
`;

export const border = css`
  border-bottom: 1px solid ${({ theme }) => theme.help.link.divider};
`;
